import { render, staticRenderFns } from "./MaterialForm.vue?vue&type=template&id=b43c49ce&scoped=true"
import script from "./MaterialForm.vue?vue&type=script&lang=js"
export * from "./MaterialForm.vue?vue&type=script&lang=js"
import style0 from "./MaterialForm.vue?vue&type=style&index=0&id=b43c49ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43c49ce",
  null
  
)

export default component.exports